import Vue from "vue";
import { isEmpty } from "./functions";

export default {
    state: Vue.observable({
        cart: Shop.cart,
        wishlist: Shop.wishlist,
        compareList: Shop.compareList,
    }),

    emptyMoneyTemplate(currency = "EUR") {
        return {
            amount: 0,
            formatted: "0,00 €",
            currency,
            inCurrentCurrency: {
                amount: 0,
                formatted: "0,00 €",
                currency,
            },
        };
    },

    emptyCartTemplate() {
        const currentCurrency =
            this.state.cart?.total?.currency ||
            this.state.cart?.subTotal?.currency ||
            "EUR";

        return {
            items: {},
            quantity: 0,
            availableShippingMethods: {},
            subTotal: this.emptyMoneyTemplate(currentCurrency),
            subTotalOrginal: this.emptyMoneyTemplate(currentCurrency),
            subDiscount: this.emptyMoneyTemplate(currentCurrency),
            shippingMethodName: null,
            shippingCost: this.emptyMoneyTemplate(currentCurrency),
            coupon: {},
            taxes: [],
            total: this.emptyMoneyTemplate(currentCurrency),
        };
    },

    cartIsEmpty() {
        return isEmpty(this.state.cart.items);
    },

    updateCart(cart) {
        this.state.cart = cart;
    },

    removeCartItem(cartItem) {
        Vue.delete(this.state.cart.items, cartItem.id);
    },

    clearCart() {
        this.state.cart = this.emptyCartTemplate();
    },

    hasShippingMethod() {
        return (
            Object.keys(this.state.cart.availableShippingMethods).length !== 0
        );
    },

    wishlistCount() {
        return this.state.wishlist.length;
    },

    inWishlist(productId) {
        return this.state.wishlist.includes(productId);
    },

    syncWishlist(productId) {
        if (this.inWishlist(productId)) {
            this.removeFromWishlist(productId);
        } else {
            this.addToWishlist(productId);
        }
    },

    addToWishlist(productId) {
        if (Shop.loggedIn) {
            this.state.wishlist.push(productId);
        } else {
            return (window.location.href = route("login"));
        }

        $.ajax({
            method: "POST",
            url: route("wishlist.store"),
            data: { productId },
        });
    },

    removeFromWishlist(productId) {
        this.state.wishlist.splice(this.state.wishlist.indexOf(productId), 1);

        $.ajax({
            method: "DELETE",
            url: route("wishlist.destroy", { productId }),
        });
    },

    inCompareList(productId) {
        return this.state.compareList.includes(productId);
    },

    syncCompareList(productId) {
        if (this.inCompareList(productId)) {
            this.removeFromCompareList(productId);
        } else {
            this.addToCompareList(productId);
        }
    },

    addToCompareList(productId) {
        this.state.compareList.push(productId);

        $.ajax({
            method: "POST",
            url: route("compare.store"),
            data: { productId },
        });
    },

    removeFromCompareList(productId) {
        this.state.compareList.splice(
            this.state.compareList.indexOf(productId),
            1
        );

        $.ajax({
            method: "DELETE",
            url: route("compare.destroy", { productId }),
        });
    },
};
